import { Section } from '../common'

type Props = {
  property: TopHap.Property
}

const MLSDescription: React.FC<Props> = ({ property }) => {
  if (!property.PublicRemarks) return null

  return (
    <Section
      contentClassName='p-4 text-xs'
      description={(
        <span>The listing agent's description. {' '}
          {property?.ListingUrl && (
            <a
              className='underline'
              href={property?.ListingUrl}
              rel='noreferrer'
              target='_blank'
            >Original Listing
            </a>
          )}
        </span>
      )}
      mode='Card'
      title='MLS Description'
    >
      {property.PublicRemarks}
    </Section>
  )
}

export default MLSDescription
